export interface TaskDueDateLabel {
  text: string;
  overdue: boolean;
}

/**
 * Builds the compact due-date subtitle shown in the compact task list:
 * "Overdue · Jul 7" (past), "Today", or "Fri, Jul 10" (future). Returns
 * "No due date" when the task has no due_at or its value can't be parsed.
 */
const taskDueDateLabel = (dueAt?: string | null): TaskDueDateLabel => {
  if (!dueAt) return { text: 'No due date', overdue: false };

  const due = new Date(dueAt);
  if (Number.isNaN(due.getTime())) return { text: 'No due date', overdue: false };

  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startOfTomorrow = new Date(startOfToday);
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1);

  const monthDay = due.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  if (due < startOfToday) {
    return { text: `Overdue · ${monthDay}`, overdue: true };
  }

  if (due < startOfTomorrow) {
    return { text: 'Today', overdue: false };
  }

  return {
    text: due.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    }),
    overdue: false
  };
};

export default taskDueDateLabel;
